/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Comment to the order
 * @export
 * @interface OrderComment
 */
export interface OrderComment {
    /**
     * 
     * @type {string}
     * @memberof OrderComment
     */
    comment?: string;
}

/**
 * Check if a given object implements the OrderComment interface.
 */
export function instanceOfOrderComment(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrderCommentFromJSON(json: any): OrderComment {
    return OrderCommentFromJSONTyped(json, false);
}

export function OrderCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderComment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function OrderCommentToJSON(value?: OrderComment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comment': value.comment,
    };
}

